__turbopack_context__.v({
  "medium": "paragraph-module-scss-module__9J7TjG__medium",
  "pad-bottom": "paragraph-module-scss-module__9J7TjG__pad-bottom",
  "pad-top": "paragraph-module-scss-module__9J7TjG__pad-top",
  "paragraph": "paragraph-module-scss-module__9J7TjG__paragraph",
  "skeleton": "paragraph-module-scss-module__9J7TjG__skeleton",
  "small": "paragraph-module-scss-module__9J7TjG__small",
});
